import React from 'react';
import { pushSelectContentEvent } from 'utils/analytics/pushSelectContentEvent';
import useMenuRedirect from 'containers/Menu/hooks/useMenuRedirect';
import { getRegion } from '../../../../../../utils/Region';
//------------------------------------------------------------------
import { FadeInImage } from '../../../../../../components/FadeInImage';
import './style.scss';
import { useNavigate } from 'react-router-dom';
import { PUSHTOHISTORY } from 'constants';
import { useSelector } from 'react-redux';
import { getContentListV1 } from 'utils/homologacion/homologacion';

export const ToonCard = ({ contentInfo, carouselTitle, contentPosition }) => {
  const { nodesSelected, navigateToChannel, handleRedirect } = useMenuRedirect();
  const { main } = useSelector(state => state.cvNavData.navData);
  const navigate = useNavigate();

  const getDataNode = data => {
    let res = undefined;
    // nivel uno
    const valueNivel1 = data?.find(
      navNode => navNode?.code === contentInfo.section,
    );

    if (valueNivel1) {
      return valueNivel1;
    }
    data?.find(nodos => {
      const valueNvel2 = nodos?.childs?.find(
        child => child?.code === contentInfo.section,
      );

      if (valueNvel2) {
        res = valueNvel2;
        return true;
      }
    });
    return res;
  };

  const handleCardClick = e => {
    e.stopPropagation();

    pushSelectContentEvent(
      contentInfo,
      nodesSelected,
      carouselTitle,
      contentPosition,
    );

    const nodeToRedirect = getDataNode(main);

    if (nodeToRedirect !== undefined && contentInfo?.section !== null) {
      handleRedirect({ node: nodeToRedirect });
      return;
    }

    if (getContentListV1?.IsLive(contentInfo)) {
      // navegar al canal
      navigateToChannel(contentInfo, PUSHTOHISTORY);
      return;
    }

    //Redireccionamiento
    navigate(
      `/${getRegion()}/vcard/homeuser/${contentInfo.title_uri}/${
        contentInfo.group_id
      }`,
    );
  };

  return (
    <div className="toon-card" onClick={handleCardClick}>
      <FadeInImage
        imageAlt="clarovideo"
        imageSrc={contentInfo.image_highlight}
        width={104}
        height={104}
        classNames={['toon-card__image']}
      />
      {contentInfo?.text_highlight && <p className="toon-card__description">{contentInfo.text_highlight}</p>}
    </div>
  );
};
